import { IJob } from './IJob';

export class Job implements IJob {
  public readonly id: string;
  public percentageComplete: number;
  public description: string;
}
